import request from '../utils/request';
 
const history = {
    selectByUserId(headers, data) {
        return request({
            method:'post',
            url:'robot/selectByUserId',
            headers,
            data
        })
    }
}
// export function getList(data) {
//     return request({
//         methods:'post',
//         url:'/save',
//         data,
//     })
// }
 
// export function selectByUserId(headers, params) {
//     return request({
//         methods:'post',
//         url:'robot/selectByUserId',
//         headers,
//         params
//     })
// }
// export function update(id,data) {
//     return request({
//         methods:'POST',
//         url:'/products/${id}',
//         data,
//     })
// }

export default history;